import { HTMLAttributes, ReactNode } from 'react';
import { tv } from 'tailwind-variants';

export interface IMenuItem extends HTMLAttributes<HTMLButtonElement> {
    label: string;
    description: string;
    icon?: ReactNode;
    active?: boolean;
}

export const MenuItem = ({
    description,
    icon,
    className,
    children,
    title,
    label,
    active = false,
    ...rest
}: IMenuItem) => {
    const variants = tv({
        base: 'border-neutral-subtle text-semantic-fg-base flex h-full w-full cursor-pointer flex-row items-start rounded-md border p-3 text-sm transition-colors duration-100 hover:bg-bg-subtle',
        variants: {
            active: {
                true: 'border-border-brand bg-bg-subtle ',
                false: '',
            },
        },
    });

    return (
        <div className={variants({ active, class: className })}>
            <button
                className='flex flex-1 cursor-pointer flex-nowrap items-center gap-3 text-left'
                {...rest}
                title={title}
            >
                {icon && (
                    <span className='border-neutral-subtle flex aspect-square w-[64px] flex-shrink-0 items-center justify-center rounded-sm border bg-white text-[40px]'>
                        {icon}
                    </span>
                )}
                <span className='flex flex-col'>
                    <span className='font-bold'>{label}</span>
                    <span className='text-theme-fg-secondary font-normal'>{description}</span>
                </span>
            </button>
            {children && <div className='flex flex-shrink-0 flex-col'>{children}</div>}
        </div>
    );
};
